import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {MapFactoryService} from "../../services/map.service";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

export class ItineraryMapComponent implements IController {
  agent: any;
  tasks: TaskModel[];
  isEditMode?: boolean;
  serviceAreasPolygons: any;
  showMapOnMobile: any;
  relatedItineraries: any;
  highlightedTaskId: any;
  agentDraggable: any;
  hiddenAgentIds: any;
  logisticsVehicles: LogisticsVehicle[];
  isUseDaySequenceAsTaskIndex: boolean;
  isCenterByAgent: boolean;
  agentRoutes: any;
  onHighlightedChanged: Function;
  onHiddenAgentIdsChange: Function;
  onAgentLocationChange: Function;
  onTasksOrderChange: Function;

  private mapRef: any;
  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  }
  private infowindow: any;
  private inActiveStatuses: any;
  private siteLocation: any;
  public taskInfoWindow: any;
  public polylineInfoWindow: any;
  private map: any;
  private agentMarker: any;
  private agentEvents: any;
  private depotEvents: any;
  private myLocation: any = undefined;
  private taskMarkers: any = [];
  public relatedAgentMarkers: any[] = [];
  private relatedTaskMarkers: any[] = [];
  private taskMarkerDepots: any[] = [];
  private routedMarkersControl: any = {};
  private relatedMarkersControl: any = {};
  private relatedPolylinesControl: any = {};
  private mapServiceAreas: any[] = [];
  private mapServiceAreasCtrl: any = {};
  private static: boolean = true;
  public logisticsVehiclesDataLayerRef: any;

  private mapInstance = undefined;
  private polylineCopy = undefined;
  private drawing = false;
  private drawingFromMarkerId = undefined;
  private firstCoords: any;
  public markerEvents: any;
  public polyline: any = {
    path: [],
    visible: true,
    stroke: {
      color: '#424242',
      weight: 2,
      opacity: 1
    }
    // icons: [{
    //     icon: {
    //         path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
    //     },
    //     offset: '50px',
    //     repeat: '150px'
    // }]
  };
  public polylineDraw: any = {
    path: [],
    visible: true,
    clickable: false,
    stroke: {
      color: '#FBB446',
      weight: 3,
      opacity: 0.7
    }
  };
  private relatedPolylines: any[] = [];
  private filters: any = {
    agent: {
      enabled: true
    },
    showAgentsWithoutGpsPermissions: {
      enabled: true
    },
    itinerary: {
      enabled: true
    },
    traffic: {
      enabled: false
    },
    satellite: {
      enabled: false
    },
    geofencing: {
      enabled: false
    },
    serviceAreas: {
      enabled: false
    }
  };
  private taskMarkersLayer: any;
  private relatedItinerariesMarkersLayer: any;
  private taskInfoWindowModel: any;
  private circleTypes: any;
  private circles: any;
  private polygonEvents: any;
  public routesDataLayerRef: any;
  public agentsRef: any;

  constructor(private $task, private mapsCommonService: MapsCommonService, private resizeService: ResizeService, private splitService: SplitService,
              private itinerariesConstant, private $mdMedia, private uiGmapIsReady, private $agent, private agentsService: AgentsService,
              private $depots, private $filter, private mapFactoryService: MapFactoryService, private $timeout: ITimeoutService, private $mdColors) {
  this.filters.showAgentsWithoutGpsPermissions.enabled = !this.splitService.getEnableLocationTrackingFilterByDefault();
  }

  $onInit() {
    this.agentsRef = this.$agent();
    this.infowindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, -20)
    });
    this.infowindow.setOptions({disableAutoPan: true});
    this.inActiveStatuses = this.itinerariesConstant.inActiveTaskStatuses;
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.taskInfoWindow = this.mapsCommonService.initActiveWindow({
      pixelOffset: new google.maps.Size(0, -40),
      disableAutoPan: true
    });
    this.polylineInfoWindow = this.mapsCommonService.initActiveWindow({
      pixelOffset: new google.maps.Size(0, 40),
      disableAutoPan: false
    });
    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.map.isReady) {
            this.mapRef = map;
            this.map.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.resizeService.resize();
            this.centerMap();
          }
          this.polylineInfoWindow.show = false;
        },
        click: () => {
          if (!this.$mdMedia('gt-md')) {
            this.$timeout(0).then(() => {
              this.infowindow.close();
              this.onHighlightedChanged({
                serviceId: undefined,
                taskId: undefined
              });
            })
          }
        },
        mousemove: (map, eventName, events, test3) => {
          const isDesktop = this.$mdMedia('gt-sm');
          if (this.drawing && isDesktop) {
            this.polylineDraw.path = [
              this.firstCoords, {latitude: events[0].latLng.lat(), longitude: events[0].latLng.lng()}
            ];

            this.polylineInfoWindow.show = true;
            this.polylineInfoWindow.coords = {latitude: events[0].latLng.lat(), longitude: events[0].latLng.lng()};
            this.$timeout(0).then(() => {
            })
          }
        }
      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      bounds: {},
      taskMarkersLayerEnabled: true,
      relatedItinerariesMarkersLayerEnabled: true,
      logisticsVehiclesLayerEnable: true,
      routesLayerEnabled: true,
      logisticsVehiclesDataLayerCallback: (layer) => {
        this.logisticsVehiclesDataLayerRef = layer;

        if (this.logisticsVehicles) {
          this._setLogisticsVehicles(this.logisticsVehicles);
        }

        // Logistics Vehicles Events - mouseover
        this.logisticsVehiclesDataLayerRef.addListener("mouseover", (event) => {
          this.$timeout(0).then(() => {
            const coordinates = event.feature.getProperty("coordinates");
            const name = event.feature.getProperty("name");

            const eventMarker = new google.maps.MVCObject();
            eventMarker.set('position', coordinates);

            this.infowindow.setContent(escapeHtml(name));
            this.infowindow.open(this.mapRef, eventMarker);
          });
        });

        // Logistics Vehicles Events - mouseout
        this.logisticsVehiclesDataLayerRef.addListener("mouseout", (event) => {
          this.infowindow.close();
        });
      },
      routesLayerCallback: (layer) => {

        this.routesDataLayerRef = layer;

        if (this.agentRoutes) {
          this.setAgentRoutes(this.agentRoutes);
        }
      },
      taskMarkersLayerCallback: (layer) => {
        this.taskMarkersLayer = layer;

        // Add events connection to data layer

        // Click
        this.taskMarkersLayer.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            if (!this.$mdMedia('gt-md')) {
              const taskId = event.feature.getProperty("id");
              const serviceId = event.feature.getProperty("serviceId");

              //Highlight Tasks
              this.$timeout(0).then(() => {
                this.onHighlightedChanged({
                  serviceId: serviceId,
                  taskId: taskId
                });
              });
            }
          })
        });

        // Mouse Over
        this.taskMarkersLayer.addListener("mouseover", (event) => {
          const taskId = event.feature.getProperty("id");
          const serviceId = event.feature.getProperty("serviceId");

          //Highlight Tasks
          this.$timeout(0).then(() => {
            this.onHighlightedChanged({
              serviceId: serviceId,
              taskId: taskId
            });
          });
        });

        // Mouse Out
        this.taskMarkersLayer.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.onHighlightedChanged({
              serviceId: undefined,
              taskId: undefined
            });
          });
        });

        if (_.get(this.tasks, 'length')) {
          this.setTaskMarkers(this.tasks, true);
        }

      },
      relatedItinerariesMarkersLayerCallback: (layer) => {
        this.relatedItinerariesMarkersLayer = layer;

        if (this.relatedItineraries && this.relatedItineraries.length) {
          this.setRelatedItinerariesTaskMarkers(this.relatedItineraries, true);
        }

      },
      layerEnable: true
    };
    this.agentMarker = {
      options: {
        icon: this.mapsCommonService.getAgentIcon(this.agent),
        visible: true,
        draggable: this.agentDraggable || false
      }
    };
    this.agentEvents = {
      click: (marker, event, model, args) => {
        this.initAgentInfoWindow(marker, model);
      },
      mouseover: (marker, event, model, args) => {
        this.initAgentInfoWindow(marker, model);
      },
      mouseout: (marker, event, model, args) => {
        this.infowindow.close();
      }
    };
    this.depotEvents = {
      click: (marker, event, model, args) => {
        this.initDepotInfoWindow(marker, model);
      },
      mouseover: (marker, event, model, args) => {
        this.initDepotInfoWindow(marker, model);
      },
      mouseout: (marker, event, model, args) => {
        this.infowindow.close();
      }
    };
    this.polygonEvents = {
      mouseover: (marker, event, model) => {
        const map = marker.map;
        const contentString =
          '<div style="text-align: center; width: 100%">' + escapeHtml(_.get(model, 'fill.name')) + '</div>';
        this.infowindow.setPosition(this.mapsCommonService.getPolygonBounds(model.path).getCenter());
        this.infowindow.setContent(contentString);
        this.infowindow.open(map, marker);
      },
      mouseout: () => {
        this.infowindow.close();
      }
    };

    this.taskMarkers = [];
    this.polyline.path = [];
    this.taskMarkerDepots = [];
    // this.relatedPolyline.path = [];

    if (!!this.agent) {
      this.agentMarker = this.mapsCommonService.buildAgentMarker(this.agent, this.filters.agent.enabled, this.filters.showAgentsWithoutGpsPermissions.enabled);
      this.circleTypes = this.mapsCommonService.getTasksRadiusPayload(this.agent);
      this.onGeofancingChange(this.filters.geofencing.enabled);
    }


    // For Edit Mode

    this.markerEvents = {
      mousedown: (marker, event, model, args) => {
        this.mapInstance = marker.map;
        const map = marker.map;
        this.drawing = true;
        this.drawingFromMarkerId = model.id;
        this.firstCoords = {latitude: marker.position.lat(), longitude: marker.position.lng()};
        map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
      },
      mouseover: (marker, event, model, args) => {
        if (this.drawing && this.drawingFromMarkerId !== model.id) {

          const filteredTaskMarkers = _.filter(this.taskMarkers, (m) => {
            return m.id !== model.id;
          });
          const drawingFromMarkerIndex = _.findIndex(filteredTaskMarkers, (m) => {
            return m.id === this.drawingFromMarkerId;
          });
          const requestedTaskIndex = drawingFromMarkerIndex + 1;
          filteredTaskMarkers.splice(requestedTaskIndex, 0, model);

          const updatedTaskMarkers = filteredTaskMarkers;

          const complementaryTaskIndex = _.findIndex(updatedTaskMarkers, (m) => {
            return m.serviceId === model.serviceId && m.id !== model.id;
          });

          if (_.isEqual(this.taskMarkers, updatedTaskMarkers) ||
            !this.isHeadingOrArrivedOrderCurrect(updatedTaskMarkers)) {
            return;
          }

          if (!complementaryTaskIndex ||
            (model.purpose === 'Pickup' && requestedTaskIndex < complementaryTaskIndex) ||
            (model.purpose === 'Dropoff' && requestedTaskIndex > complementaryTaskIndex) ||
            model.purpose === 'Operation') {

            this.polylineCopy = angular.copy(this.polyline);
            this.polyline.path = this.getPolylinePath(updatedTaskMarkers);
          }

        }
      },
      mouseout: (marker, event, model, args) => {
        if (this.drawing && this.polylineCopy) {
          this.polyline = this.polylineCopy;
          this.polylineCopy = undefined;
        }
      }
    };

    this.mapFactoryService.getBrowserLocation()
      .then((res: any) => {
        this.myLocation = this.mapsCommonService.buildMyLocationMarker(res.coords);
      })
      .catch((err) => {

      })


    // Edit Mode Line
    this.polyline = {
      path: [],
      visible: true,
      stroke: {
        color: this.$mdColors.getThemeColor('red-300'),
        weight: 2,
        opacity: 0.7
      },
      icons: [{
        icon: {
          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
        },
        offset: '50px',
        repeat: '150px'
      }]
    };

    // this.uiGmapIsReady.promise(1).then((maps) => {
    //   // Init drawing listener
    //   this.mapInstance = maps[0].map.controls.getGMap();
    //   google.maps.event.addListener(this.mapInstance, 'mousemove', (event) => {
    //     const isDesktop = this.$mdMedia('gt-sm');
    //     if (this.drawing && isDesktop) {
    //       this.polylineDraw.path = [
    //         this.firstCoords, {latitude: event.latLng.lat(), longitude: event.latLng.lng()}
    //       ];
    //       this.$timeout(0).then(() => {
    //       })
    //     }
    //   });
    // });

    this.centerMap();
  }

  private setAgentRoutes(routes) {
    if (this.routesDataLayerRef) {

      _.forEach(routes, (r) => {
        const geoJson = this.mapsCommonService.convertRoutedActivitiesToGeoJson(r);

        // Add routes to layer
        this.routesDataLayerRef.addGeoJson(geoJson);

        // Set feature style by its properties
        this.setRoutesStyle();
      })
    }
  }

  $onChanges(changes) {
    //Agent changed
    if (changes.agent && !changes.agent.isFirstChange()) {
      const currentAgent = changes.agent.currentValue,
        previousAgent = changes.agent.previousValue;

      this.agentMarker = this.mapsCommonService.buildAgentMarker(this.agent, this.filters.agent.enabled, this.filters.showAgentsWithoutGpsPermissions.enabled);

      if (!!currentAgent) {
        this.circleTypes = this.mapsCommonService.getTasksRadiusPayload(currentAgent);
        this.onGeofancingChange(this.filters.geofencing.enabled);
      }

      if (_.get(currentAgent, 'id') !== _.get(previousAgent, 'id')) {
        this.centerMap();
      }
    }

    if (changes.tasks && !changes.tasks.isFirstChange()) {
      if (this.isEditMode) {
        this.taskMarkers = this.getEditModeTaskMarkers(this.tasks);
        this.polyline.path = this.getPolylinePath(this.taskMarkers);
      } else {
        const currentTasks = _.get(changes, 'tasks.currentValue', []),
          previousTasks = _.get(changes, 'tasks.previousValue', []);

        if (!!previousTasks.length) {
          // this.removeTasksFromDataLayer(_.flatMap(previousTasks, 'agentId'));
          this.removeTasksFromDataLayer();
        }

        if (!!currentTasks.length) {
          const doCenterMap = !_.get(previousTasks, 'length');
          this.setTaskMarkers(currentTasks, doCenterMap);
        }
      }
    }

    if (changes.isEditMode && !changes.isEditMode.isFirstChange()) {
      this.map.taskMarkersLayerEnabled = !this.isEditMode;
      this.taskMarkers = this.isEditMode ? this.getEditModeTaskMarkers(this.tasks) : [];
      this.polyline.path = this.isEditMode ? this.getPolylinePath(this.taskMarkers) : [];
    }

    if (changes.relatedItineraries && !changes.relatedItineraries.isFirstChange()) {

      const currentRelatedItineraries = changes.relatedItineraries.currentValue,
        previousRelatedItineraries = changes.relatedItineraries.previousValue;

      const relatedItinerariesToAdd = _.differenceBy(currentRelatedItineraries, previousRelatedItineraries, 'id');
      const relatedItinerariesRemove = _.differenceBy(previousRelatedItineraries, currentRelatedItineraries, 'id');

      if (!!relatedItinerariesRemove.length) {
        this.removeRelatedItinerariesFromDataLayer(_.flatMap(relatedItinerariesRemove, 'agent.id'));
      }

      if (_.get(currentRelatedItineraries, 'length')) {
        const reCenterMap = !_.get(previousRelatedItineraries, 'length');
        this.setRelatedItinerariesTaskMarkers(relatedItinerariesToAdd, reCenterMap);
      }
    }

    //Task clicked (Active window)
    if (changes.highlightedTaskId && !changes.highlightedTaskId.isFirstChange()) {
      const currentHighlightedTaskId = changes.highlightedTaskId.currentValue,
        previousHighlightedTaskId = changes.highlightedTaskId.previousValue;
      if (!_.isEqual(currentHighlightedTaskId, previousHighlightedTaskId)) {
        let taskForHighlight = _.find(this.tasks, (t) => {
          return _.isEqual(t.id, currentHighlightedTaskId);
        });


        if (!taskForHighlight) {
          taskForHighlight = _.find(this.relatedTaskMarkers, (marker) => {
            return _.isEqual(marker.id, currentHighlightedTaskId);
          });
        }

        this.setTaskInfoWindow(taskForHighlight);
      }
    }

    if (changes.hiddenAgentIds && !changes.hiddenAgentIds.isFirstChange()) {

      // Set feature style by its properties

      if (this.taskMarkersLayer) {
        this.resetTaskMarkersLayerStyle();
      }

      // Set feature style by its properties
      if (this.relatedItinerariesMarkersLayer) {
        this.resetRelatedItinerariesMarkersLayerStyle();
      }

      this.setRelatedAgentsMarkersVisibility();
    }

    if (changes.showMapOnMobile && !changes.showMapOnMobile.isFirstChange()) {
      if (this.showMapOnMobile) {
        setTimeout(() => {
          this.$onInit()
        }, 2000);
      }
    }

    if (changes.serviceAreasPolygons && !changes.serviceAreasPolygons.isFirstChange()) {
      this.serviceAreasPolygons = changes.serviceAreasPolygons.currentValue;
      this.mapServiceAreas = this.filters.serviceAreas.enabled ?
        this.getMapServiceAreas(changes.serviceAreasPolygons.currentValue) : [];
    }

    if (changes.logisticsVehicles && !changes.logisticsVehicles.isFirstChange()) {
      this._removeLogisticsVehiclesFromDataLayer();
      this._setLogisticsVehicles(this.logisticsVehicles);
    }

    if (changes.agentRoutes) {

      this.routesDataLayerRef.forEach((feature) => {
        this.routesDataLayerRef.remove(feature);
      });

      this.setAgentRoutes(this.agentRoutes);
    }
  }

  onGeofancingChange(isEnabled) {
    this.circles = [];
    if (isEnabled) {

      this.taskMarkersLayer.forEach((feature) => {
        const address = feature.getProperty('address');

        if (address && address.location) {
          const taskCircles = angular.copy(this.circleTypes);
          taskCircles[0].center = address.location;
          taskCircles[1].center = address.location;
          this.circles = this.circles.concat(taskCircles);
        }
      });

    }
  }

  onToggleAgent() {
    this.agentMarker.options.visible = !this.filters.showAgentsWithoutGpsPermissions.enabled ?
      (this.filters.agent.enabled && this.agentsService.doesAgentHasGpsPermissions(this.agent)) :
      !!this.filters.agent.enabled;
  }

  onToggleAgentsByGpsPermissionsChange() {
    // Agent Marker
    this.onToggleAgent();

    // Related Agents Markers
    this.setRelatedAgentsMarkersVisibility();
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic.enabled = false;
    }
  }

  centerMap() {
    const markers = this.getAllMarkers();
    this.$timeout(0).then(() => {
      this.mapsCommonService.centerMapByBounds(this.map, markers);
      if (this.isCenterByAgent) {
        this.$timeout(() => {
          this.mapRef?.setZoom(10);
        }, 0);
      }
    });
  }

  // function sortTaskMarkers(taskMarkers, taskIds) {
  //   return _.sortBy(taskMarkers, [function (taskMarker) {
  //     var index = _.indexOf(taskIds, taskMarker.id) + 1;
  //     return index - 1;
  //   }]);
  // }

  getPolylinePath(allMarkers) {
    let path = [];
    _.forEach(allMarkers, (marker) => {
      path.unshift(
        {
          latitude: marker.coords.latitude,
          longitude: marker.coords.longitude,
          id: marker.id
        }
      )
    });
    return path;
  }

  toggleShowItinerary(isEnabled) {
    let hiddenAgentIdsCopy = angular.copy(this.hiddenAgentIds);
    if (isEnabled) {
      hiddenAgentIdsCopy = _.filter(this.hiddenAgentIds, (id) => {
        return id !== this.agent.id;
      })
    } else {
      hiddenAgentIdsCopy.push(this.agent.id);
    }
    this.onHiddenAgentIdsChange({ids: _.uniq(hiddenAgentIdsCopy)});
  }

  onToggleShowServiceAreas(isEnabled) {
    this.mapServiceAreas = isEnabled ? this.getMapServiceAreas(this.serviceAreasPolygons) : [];
  }

  onTaskMarkerClick(marker, eventName, model) {
    //Highlight Tasks
    this.onHighlightedChanged({
      serviceId: model.serviceId,
      taskId: model.id
    });
  }

  setTaskInfoWindow(task: TaskModel) {
    if (task) {
      this.taskInfoWindow.show = true;
      this.taskInfoWindow.coords = _.get(task, 'taskSpec.address.location');
      this.taskInfoWindowModel = task;
    } else {
      // this.taskInfoWindow.show = false;
      this.taskInfoWindowModel = undefined;
    }
  }

  private getMapServiceAreas(serviceAreas) {
    return this.mapsCommonService.buildPolygons(serviceAreas, true);
  }

  private setTaskMarkers(tasks, doCenterMap) {
    if (this.taskMarkersLayer) {
      const geoJson = this.mapsCommonService.convertItineraryTasksToGeoJson(tasks, _.get(this, 'agent.id'), this.isUseDaySequenceAsTaskIndex);

      // Add routes to layer
      this.taskMarkersLayer.addGeoJson(geoJson);

      // Set feature style by its properties
      this.resetTaskMarkersLayerStyle();

      if (doCenterMap) {
        this.centerMap();
      }
    }
  }


  private resetTaskMarkersLayerStyle() {
    this.taskMarkersLayer.setStyle((feature) => {
      const updatedVisible = !_.includes(this.hiddenAgentIds, feature.getProperty('agentId'));
      const currentVisible = feature.getProperty('visible');

      if (!_.isEqual(currentVisible, updatedVisible)) {
        return this.mapsCommonService.getTaskFeatureStyle(feature, updatedVisible);
      }
    });
  }

  private resetRelatedItinerariesMarkersLayerStyle() {
    if (this.relatedItinerariesMarkersLayer) {
      this.relatedItinerariesMarkersLayer.setStyle((feature) => {

        const updatedVisible = !_.includes(this.hiddenAgentIds, feature.getProperty('agentId'));
        const currentVisible = feature.getProperty('visible');

        if (!_.isEqual(currentVisible, updatedVisible)) {
          return this.mapsCommonService.getTaskFeatureStyle(feature, updatedVisible);
        }
      });
    }
  }

  private setRelatedItinerariesTaskMarkers(relatedItineraries, doCenterMap) {
    if (this.relatedItinerariesMarkersLayer) {
      let taskIds = _.flatMap(relatedItineraries, 'taskIdListExt') || [];
      let agentIds = relatedItineraries.map(ri => ri.agentRef.id);

      this.relatedAgentMarkers = [];

      this.agentsRef.$asyncValues(agentIds)
        .then((agents) => {
          _.forEach(agents, (agent) => {
            let relatedAgentMarker = this.mapsCommonService.buildAgentMarker(agent, this.map.relatedItinerariesMarkersLayerEnabled, this.filters.showAgentsWithoutGpsPermissions.enabled);
            this.relatedAgentMarkers.push(relatedAgentMarker);
          })

          this.setRelatedAgentsMarkersVisibility();
        })

      this.$task().$asyncValues(taskIds)
        .then((tasks) => {
          const geoJson = this.mapsCommonService.convertItinerariesToGeoJson(relatedItineraries, tasks, this.isUseDaySequenceAsTaskIndex);

          // Add itineraries to layer
          this.relatedItinerariesMarkersLayer.addGeoJson(geoJson);

          // Set feature style by its properties
          this.resetRelatedItinerariesMarkersLayerStyle();

          if (doCenterMap) {
            this.centerMap();
          }
        })
    }
  }

  private initTaskMarkerDepots(depotIds) {
    this.$depots().$asyncValues(depotIds)
      .then((depots) => {
        this.taskMarkerDepots = this.mapsCommonService.getDepotMarkers(depots);
      })
  }

  private getAllMarkers() {
    let markers = [];

    if (this.isCenterByAgent && !_.isUndefined(this.agentMarker)) {
      if (this.agentMarker.coords) {
        const fakeMarker = new google.maps.MVCObject();
        fakeMarker.set('coords', this.agentMarker.coords);
        markers.push(fakeMarker);
      }
    } else {


      if (!_.isUndefined(this.taskMarkersLayer)) {
        this.taskMarkersLayer.forEach((feature) => {
          const address = feature.getProperty('address');

          if (address && address.location) {
            const fakeMarker = new google.maps.MVCObject();
            fakeMarker.set('coords', {'latitude': address.location.lat, 'longitude': address.location.lng});
            markers.push(fakeMarker);
          }
        });
      }
      if (!_.isUndefined(this.relatedItinerariesMarkersLayer)) {
        this.relatedItinerariesMarkersLayer.forEach((feature) => {
          const address = feature.getProperty('address');

          if (address && address.location) {
            const fakeMarker = new google.maps.MVCObject();
            fakeMarker.set('coords', {'latitude': address.location.lat, 'longitude': address.location.lng});
            markers.push(fakeMarker);
          }
        });
      }


    }

    return markers;
  }

  private getAllAgentIds() {
    const agentIds = _.map(this.relatedPolylines, 'agentId')
    if (_.get(this.agent, 'id')) {
      agentIds.push(this.agent.id);
    }
    return agentIds;

  }

  private setMarkersVisibility(markers, isFilterOn) {
    _.forEach(markers, (m) => {
      m.setVisible(isFilterOn ? !_.includes(this.hiddenAgentIds, m.model.agentId) : false);
    });
  }

  private initAgentInfoWindow(marker, model) {
    const map = marker.map;
    this.infowindow.setContent(escapeHtml(this.$filter('userName')(_.get(model, 'options.ref.user'))));
    this.infowindow.open(map, marker);
  }

  private initDepotInfoWindow(marker, model) {
    const map = marker.map;
    this.infowindow.setContent(escapeHtml(_.get(model, 'name')));
    this.infowindow.open(map, marker);
  }

  private removeTasksFromDataLayer(removeByAgentIds?) {
    if (this.taskMarkersLayer) {
      this.taskMarkersLayer.forEach((feature) => {
        if (_.get(removeByAgentIds, 'length')) {
          var featureAgentId = feature.getProperty('agentId');
          if (_.includes(removeByAgentIds, featureAgentId)) {
            this.taskMarkersLayer.remove(feature);
          }
        } else {
          this.taskMarkersLayer.remove(feature);
        }
      });
    }
  }

  private removeRelatedItinerariesFromDataLayer(removeByAgentIds) {
    if (this.relatedItinerariesMarkersLayer) {
      this.relatedItinerariesMarkersLayer.forEach((feature) => {
        if (_.get(removeByAgentIds, 'length')) {
          var featureAgentId = feature.getProperty('agentId');
          if (_.includes(removeByAgentIds, featureAgentId)) {
            this.relatedItinerariesMarkersLayer.remove(feature);
          }
        } else {
          this.relatedItinerariesMarkersLayer.remove(feature);
        }
      });
    }
  }

  private _removeLogisticsVehiclesFromDataLayer(removeByLogisticsVehiclesIds?) {
    if (this.logisticsVehiclesDataLayerRef) {
      this.logisticsVehiclesDataLayerRef.forEach((feature) => {
        if (_.get(removeByLogisticsVehiclesIds, 'length')) {
          const featureId = feature.getProperty('id');
          if (_.includes(removeByLogisticsVehiclesIds, featureId)) {
            this.logisticsVehiclesDataLayerRef.remove(feature);
          }
        } else {
          this.logisticsVehiclesDataLayerRef.remove(feature);
        }
      });
    }
  }

  private _setLogisticsVehicles(logisticsVehicles) {
    if (this.logisticsVehiclesDataLayerRef) {
      const geoJson = this.mapsCommonService.convertLogisticsVehiclesToGeoJson(logisticsVehicles);

      // Add routes to layer
      this.logisticsVehiclesDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.setLogisticsVehiclesStyle();
    }
  }

  private setLogisticsVehiclesStyle() {
    if (this.logisticsVehiclesDataLayerRef) {
      this.logisticsVehiclesDataLayerRef.setStyle((feature) => {
        // const routeId = feature.getProperty('routeId'),
        //   jobId = feature.getProperty('jobId'),
        //   isVisible = _.includes(this.hiddenRouteIds, routeId) ? false : this.filters.routes,
        //   isSelected = _.includes(this.selectedJobIds, jobId);
        // isSelected = _.isEqual(feature.getProperty('id'), ctrl.selectedActivityId);

        return this.mapsCommonService.getLogisticsVehicleStyle(feature);
      });
    }
  }


  // EDIT MODE

  onMouseUp(event) {
    if (this.drawing) {

      this.polylineDraw.path = [];
      this.drawing = false;
      this.drawingFromMarkerId = undefined;

      this.mapInstance.setOptions({draggable: true, zoomControl: true, scrollwheel: true, disableDoubleClickZoom: true});

      this.map.options.draggable = true;
      this.map.options.zoomControl = true;
      this.map.options.scrollwheel = true;
      this.map.options.disableDoubleClickZoom = true;

      const startDay = _.find(this.tasks, (t) => {
        return t.taskSpec.purpose === 'StartDay'
      })
      const endDay = _.find(this.tasks, (t) => {
        return t.taskSpec.purpose === 'EndDay'
      })

      if (this.polylineCopy) {
        const taskIds = _
          .chain(this.polyline.path)
          .map((path) => {
            return path.id;
          })
          .reverse()
          .value();

        this.polylineCopy = undefined;

        if (startDay) {
          taskIds.unshift(startDay.id)
        }
        if (endDay) {
          taskIds.push(endDay.id)
        }

        this.onTasksOrderChange({taskIds: taskIds});
      }

    } else {
      this.polylineInfoWindow.show = false;
      this.map.options.draggable = true;
      this.map.options.zoomControl = true;
      this.map.options.scrollwheel = true;
      this.map.options.disableDoubleClickZoom = true;
    }
  }


  getEditModeTaskMarkers(tasks) {
    //return mapsCommon.getRouteTaskMarkersWithStatus(tasks, true);
    let taskMarkers = [];
    _.forEach(tasks, (task, index) => {

      if (!_.get(task, 'taskSpec.address.location')) {
        return;
      }

      let taskIndex = index + 1;
      let status = task.status;
      let purpose = task.taskSpec.purpose;
      let isBundle = _.isEqual(task.taskType, 'BundledStopover')
      taskMarkers.push(
        {
          id: task.id,
          coords: task.taskSpec.address.location,
          // icon: mapsCommon.buildTaskIcon(task.taskSpec.purpose),
          icon: this.mapsCommonService.buildRoutedTaskIconWithStatus(task.taskSpec.purpose, task.status, index + 1, false, isBundle),
          // icon: mapsCommon.buildTaskIconPlaceholderWithStatus(purpose, status),
          options: {
            // labelClass: mapsCommon.getLabelClassByTask(task, true),
            // labelContent: taskIndex,
            // labelAnchor: (taskIndex >= 100 ? '9' : taskIndex >= 10 ? '6' : '3') + ' 20'
            // zIndex: 30 + taskIndex,
            // label: {
            //     text: taskIndex.toString(),
            //     color: _.get(mapsCommon.markerConfig[purpose], 'color', mapsCommon.markerConfig.Default.color),
            //     fontSize: '12px',
            //     fontWeight: 'bold'
            // }
          },
          purpose: purpose,
          status: status,
          serviceId: task.serviceId
        }
      )
    });
    return taskMarkers;
  }

  private isHeadingOrArrivedOrderCurrect(taskMarkers) {
    let taskHeadingLastIndex: any = -1;
    let regularTaskFirstIndex: any = -1;

    _.forEach(taskMarkers, (taskMarker, index) => {
      if (this.isTaskHeadingOrArrived(taskMarker)) {
        taskHeadingLastIndex = index;
      } else if (regularTaskFirstIndex === -1) {
        regularTaskFirstIndex = index
      }
    });
    return regularTaskFirstIndex > taskHeadingLastIndex;
  }

  private isTaskHeadingOrArrived(task: TaskModel) {
    return _.isEqual(task.status, 'CourierHeading') || _.isEqual(task.status, 'CourierArrived');
  }

  private setRoutesStyle() {
    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.setStyle((feature) => {
        return this.mapsCommonService.getActivityFeatureStyle(feature);
      });
    }
  }

  private setRelatedAgentsMarkersVisibility() {
    this.relatedAgentMarkers.forEach(marker => {
      marker.options.visible = !this.hiddenAgentIds.includes(marker.options.ref.id) ?
        (this.filters.agent.enabled && this.agentsService.doesAgentHasGpsPermissions(marker.options.ref)) :
        this.filters.agent.enabled;
    })
  }


}

angular
  .module('bringoz.admin.map')
  .component('itineraryMap', {
    bindings: {
      agent: '<',
      tasks: '<',
      isEditMode: '<?',
      serviceAreasPolygons: '<?',
      logisticsVehicles: '<?',
      showMapOnMobile: '<',
      relatedItineraries: '<',
      highlightedTaskId: '<',
      agentDraggable: '<?',
      hiddenAgentIds: '<',
      isUseDaySequenceAsTaskIndex: '<',
      isCenterByAgent: '<?',
      agentRoutes: '<?',
      onHighlightedChanged: '&',
      onHiddenAgentIdsChange: '&',
      onAgentLocationChange: '&',
      onTasksOrderChange: '&'
    },
    template: require('./itinerary-map.tmpl.html').default,
    controller: ItineraryMapComponent
  });

